import React, { useState } from "react";
import { Link } from "react-router-dom";
import BlackLogo from '../../images/Siamois/logo/logo-black.svg'
import './Registration.css'
import {useMediaQuery} from "@material-ui/core";
import {useHistory} from "react-router";


const Registration = () => {
    const sm = useMediaQuery('(min-width:576px)');
    const md = useMediaQuery('(min-width:768px)');
    const lg = useMediaQuery('(min-width:992px)');
    const xl= useMediaQuery('(min-width:1200px)');
    let history=useHistory();

    const [registrationData, setRegistrationData] = useState({});
    const handleBlur = (e) => {
        const newRegistrationData = { ...registrationData };
        newRegistrationData[e.target.name] = e.target.value;
        setRegistrationData(newRegistrationData);
    };
    const submitHandler = (e) => {
        e.preventDefault();
        const submitRegister = { ...registrationData };
    };
    return (
        <React.Fragment>
            <div className="d-flex justify-content-center mt-1">
                <img style={ {height : lg ? '5rem' : '3rem'} } src={BlackLogo} alt=""/>
            </div>
            <div className="mt-3 authincation mb-4">
                <div className="container p-0">
                    <div className="row justify-content-center align-items-center authincation-page-area">
                        <div className="col-lg-6 col-md-9">
                            <div className="authincation-content">
                                <div className="row no-gutters mb-4">
                                    <div className="col-xl-12">
                                        <div className="auth-form">
                                            <div style={{fontSize : '1.7rem'}} className="mb-4">
                                                Register your account
                                            </div>
                                            <h5 className="mb-4">
                                                Let's start setting up your account. <br/>
                                                It takes less than one minute.
                                            </h5>

                                            <form
                                                action=""
                                                onSubmit={(e) =>
                                                    e.preventDefault(submitHandler)
                                                }
                                            >
                                                <div className="form-group">
                                                    <label className="mb-1">
                                                        <strong>Username</strong>
                                                    </label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="username"
                                                        name="name"
                                                        onChange={handleBlur}
                                                    />
                                                </div>
                                                <div className="form-group">
                                                    <label className="mb-1">
                                                        <strong>Email</strong>
                                                    </label>
                                                    <input
                                                        type="email"
                                                        className="form-control"
                                                        placeholder="hello@example.com"
                                                        name="Email"
                                                        onChange={handleBlur}
                                                    />
                                                </div>
                                                <div className="form-group">
                                                    <label className="mb-1">
                                                        <strong>Password</strong>
                                                    </label>
                                                    <input
                                                        type="password"
                                                        className="form-control"
                                                        defaultValue="Password"
                                                        name="password"
                                                        onChange={handleBlur}
                                                    />
                                                </div>
                                                <div className="text-center mt-4">
                                                    <button
                                                        type="submit"
                                                        className="btn btn-primary btn-block"
                                                        onClick={() => {
                                                            history.push({
                                                                pathname: '/',
                                                                state: { registration: true }
                                                            });
                                                        }}
                                                    >
                                                        Sign me up
                                                    </button>
                                                </div>
                                            </form>
                                            <div className="new-account mt-3">
                                                <p>
                                                    Already have an account?{" "}
                                                    <Link
                                                        className="text-primary"
                                                        to="/login"
                                                    >
                                                        Sign in
                                                    </Link>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>

    );
};

export default Registration;
